<template>
  
    <div class="fullScreen">
      <div :style="'height:100%;width:100%;position:absolute; transform-origin:'+zoomX+'% 100%;transform:scale('+zoomScale+');'">
      <div class="cockpit"  :style="'opacity:1;transform:scale('+shipScale+') translate('+shipLeft+'px,'+shipTop+'px);'">
        <div class=consoleBtns>
          <div @click="transTo('game','Back to the Lighthouse')" :class="'consoleBtn '+homeBtnMode">HOME</div>
          <div @click="goTo('planning')" :class="'consoleBtn '+planBtnMode">PLAN</div>
          <div @click="startCourse" :class="'consoleBtn '+scanBtnMode">SCAN</div>
          <div @click="showDetails=true" :class="'consoleBtn '+detailBtnMode">DETAILS</div>
          <div @click="doDive()" :class="'consoleBtn '+diveBtnMode">DIVE</div>
        </div>
        <div class="shipHUD">
          <div class="lhs" v-html="scanText"></div>
          <div class="rhs">{{searchLabel}}<br>Search Area {{ polyArea}} km²<br> Search Time {{searchTime}} hrs</div>
          <div class="helpIcon" @click="showHelp" style="top: 26px;right: 21px; transform: scale(-1.2,1.2);"></div>
        </div>
        <div class="shipScan" v-if="showScan || true">
          <DepthMap :doScan="doScan" :imagePath="depthMapPath" ></DepthMap>
        </div>
        <div class="shipMap" ref="scanMapHolder" :style="'transform-origin:'+mapRight+'% '+mapBase+'%;'">
          <LeafletMap :enableScan="true" ref="scanMap" @searchUpdate="searchUpdate" @foundLoc="foundLoc" @scanFinished="scanFinished" @polyChange="doPolyUpdate" @doPolyMove="doPolyMove"></LeafletMap>
       <div v-if="false" class="mapKey">
    Key<br>
    <div v-for="key in locationInfo" :key="key.id">
       <div v-if="!key.hideKey">
      <div class="keyDot" :style="'border:solid 2px '+key.color+';'"></div>{{key.name}}
      </div>
    </div>
  </div>
       
        </div>
        <div class="cockpitJSR" @click="zoomMap"></div>
        <div class="cockpitJSL" @click="zoomScan"></div>
      </div>
    </div>
    <div v-if="showDetails" class="scanDetails">
      <h2>Scan Results<br></h2>
      <div v-if="true" class="helpClose" @click="showDetails=false">x</div>
      <div v-if="!foundData">Nothing Found</div>
      <div v-for="item in foundData" :key="item.r">
        <div v-if="item.revealed" class="scanInfo">
          {{itemByCode(item.r).sCode}} : materials:{{itemByCode(item.r).materials}}<br>Dimensions:{{itemByCode(item.r).dimensions}}<br>Depth: {{itemByCode(item.r).depth}}
          <div @click="doDive(item.r)" class="locDiveBtn">Dive on this location</div>
        </div>
      </div>
    </div>
     <ShipAction :showActions="showActions" :actionText="foundText"></ShipAction>
    <div class="debug">
     
     </div>
        <Ocean style="height:50%" :time="oceanTime"></Ocean>
       
      </div>
 
</template>

<script>
import gsap from "gsap";
import Ocean from "@/components/ThreeD/Ocean"
import screen from "@/mixins/screen"
import Help from '@/mixins/help'
import BasicMap from "@/components/LeafletMap.vue";
import LeafletMap from '@/components/LeafletMap'
import DepthMap from "@/components/panels/DepthmapShip"
import ShipAction from "@/components/panels/ShipAction"
export default {
  name: "Ship",
  components: {
    BasicMap,DepthMap,Ocean,LeafletMap,ShipAction
  
  },
  mixins:[ screen,Help],
  data() {
    return {
      oceanTime:7,
      foundPoints:[],
      
      mapBase:50,
      mapRight:50,
      doScan:false,
      showScan:false,
      scanText:"Scan Ready",
      imageWidth:2000,
      imageHeight:1125,
      mapState:"shipMapFS",
      zoomScale:1,
      zoomX:50,
      depthMapPath:'depthMapEmpty.png',
      polyArea:null,
      searchTime:0,
      timeSearched:0,
      shipX:0,
      shipY:0,
      shipVal:0,
      scanPaused:false,
      foundItem:null,
      showDetails:false,
      planBtnMode:"isPassive",
      homeBtnMode:"isPassive",
      scanBtnMode:"isActive",
      detailBtnMode:"isPassive",
      diveBtnMode:"isPassive",
      showActions:false,
      
      
      helps:[	
        {id:"H008_welcomeAboard",showOnce:true,shown:false,help:{}},
				{id:"H012_scanning",showOnce:false,shown:false,help:{}},
        {id:"H301_home",showOnce:false,shown:false,help:{}},
        {id:"H302_nothing",showOnce:false,shown:false,help:{}},
        
      ],
      foundTextList:[
        "I have found an object of interest. This doesn't match any evidence you have collected. You can dive here or keep scanning.",
        "I have found an object of interest. This looks to be of the same materials you are looking for. You can dive here or keep scanning.",
        "I have found an object of interest. This looks to be of the size and materials you are looking for. You can dive here or keep scanning.",
        "Scanning has finished. Nothing else has shown up. Review the details of your scan or choose a new area."
      ],
      foundText:""
    };
  },
  mounted(){
    if(!this.wrecks){
       this.$store.dispatch("loadWrecks")
       return
    }
    
     if(this.transFrom=="dive"){
       let numEvi=Object.keys(this.activeWreckStatus.diveEvi).length
       if(this.activeWreckStatus && numEvi>=3){
          this.$store.dispatch("showBasicHelp",{text:"You have enough evidence to suggest that this is the right wreck. You can now start planning you exhibition.",delay:5})
       }else{
         this.$store.dispatch("showBasicHelp",{text:"You don't have the evidence you need to identify the wreck. Try Scanning parts of the wreck and other objects or try diving another area.",delay:5})
    
       }
       
     }else{
        gsap.delayedCall(2,this.showHelp)
     }
     this.$store.commit("setSettingsClass","settingsIcon ship")
     this.$refs.scanMap.setEnabled(true)
     if(this.mapInfo){
       if(this.$refs.depthScan){
        this.$refs.scanMap.setMapInfo(this.mapInfo)
       }else{
          this.$nextTick(() => {
            this.$refs.scanMap.setMapInfo(this.mapInfo)
        })
       }
     }
  },
  computed:{
    items(){
      return {
       //  enterprise240:{sCode:"RI 277",gtlf:"enterprise",materials:"Timber",dimensions:"30m x 9m",depth:"30m",match:["material,dimension"], model:this.fireBaseLoc+"wrecks%2Fenterprise%2FENDEAVOUR%20BAKED%202048.gltf?alt=media&token=748d85bd-0a5f-4970-8286-8cfd392e49b5"},
       
        enterprise240:{sCode:"RI 277",gtlf:"enterprise",materials:"Timber",dimensions:"30m x 9m",depth:"30m",match:["material,dimension"], model:this.fireBaseLoc+"wrecks%2Fenterprise%2FENDEAVOUR-06.gltf?alt=media&token=1fe16da3-5c9a-4333-aaf8-883b1de967d1"},
        verdoemd240:{sCode:"WA 367", gtlf:"verdoemd",materials:"Timber",dimensions:"60m x 12m",depth:"30m",match:["material,dimension"], model:this.fireBaseLoc+"wrecks%2Fverdoemd%2FVerdomed-5.gltf?alt=media&token=444cb7a8-4086-4ed9-bd61-a2a802c67ddf"},
        pandemonium240:{sCode:"NQ 071", gtlf:"pandemonium",materials:"Timber",dimensions:"35m x 10m",depth:"30m",match:["material,dimension"], model:this.fireBaseLoc+"wrecks%2Fpandemonium%2FPandemonium_4.gltf?alt=media&token=88c0469a-e3ab-4dab-9080-705676f6bb00"},
        sub240:{sCode:"SH 167",gtlf:"sub",materials:"Steel",dimensions:"25m x 2m",depth:"30m",match:["material,dimension"], model:this.fireBaseLoc+"wrecks%2Fsub%2FM28Sub4.gltf?alt=media&token=5712974f-995e-42d5-9593-24c0c36e7302"},
        sub230:{sCode:"SH 133",gtlf:"sub",materials:"Steel",dimensions:"25m x 2m",depth:"30m",match:["material,dimension"], model:this.fireBaseLoc+"wrecks%2Fsub%2FM28SubJunk.gltf?alt=media&token=cb2ea2c0-7638-4d56-b4c8-55370d499c7b"},
      
        bermagui230:{sCode:"EC 311",gtlf:"bermagui",materials:"Timber",dimensions:"5m x 2m",depth:"30m",match:["material"], model:this.fireBaseLoc+"wrecks%2Fbermagui%2FBERMAGUI_DINGY.gltf?alt=media&token=6bfa2566-4e73-45ba-82e5-3eb27401557f"},
        bermagui240:{sCode:"EC 271",gtlf:"bermagui",materials:"Steel",dimensions:"58m x 58m",depth:"30m",match:["material,dimension"], model:this.fireBaseLoc+"wrecks%2Fbermagui%2FBERMAGUI-8.gltf?alt=media&token=1cabc048-5005-4138-95ac-ac6cbf192105"},
       
        bomber240:{sCode:"NA 137",gtlf:"bomber",materials:"Aluminium",dimensions:"20m x 15m",depth:"50m",match:["material,dimension"], model:this.fireBaseLoc+"wrecks%2Fbomber%2FBEAUFORT_5.gltf?alt=media&token=7b6287bc-e971-46fc-a0f5-44753b5950c3"},
        bomber230:{sCode:"NA 316",gtlf:"dingy",materials:"Timber",dimensions:"6m x 1.2m",depth:"20m",match:["none"], model:this.fireBaseLoc+"wrecks%2Fbomber%2FDingy3.gltf?alt=media&token=7de2e67e-86d0-43de-b7c0-2db29f54ff93"},
        bomber220:{sCode:"NA 029",gtlf:"plane",materials:"Aluminium",dimensions:"8.3m x 11m",depth:"40m",match:["material"],model:this.fireBaseLoc+"wrecks%2Fbomber%2FOtherPlaneNC.gltf?alt=media&token=29c72d6f-294b-44a3-8b80-9fd99d13758f"},
        bomber250:{sCode:"NA 051",gtlf:"torpedo",materials:"Steel",dimensions:"6.25m x 0.5m",depth:"50m",match:["none"],model:this.fireBaseLoc+"wrecks%2Fbomber%2Ftorpedo.gltf?alt=media&token=27593b0b-4a06-427d-8eba-31b9a64f11eb"}
      }
      },
    fireBaseLoc(){
				return this.$store.getters.getFireBaseLoc					
			},
    transFrom(){
      if(this.lastTrans){
        return this.lastTrans.from
      }
    },
    lastTrans(){
      return this.$store.getters.getTransition
    },
    searchLabel(){
      if(this.wreck && this.wreck.searchArea){
        return this.wreck.searchArea
      }
      return ""
    },
   wrecks(){
     return this.$store.getters.getWrecks
   },
    wreck(){
       
       if(this.$store.getters.getWreck){
         return this.$store.getters.getWreck
       }else{
        
         return this.$store.getters.getWreck
       }
    },
    wreckStatus(){
        return this.$store.getters.getWreckStatus
      },
      activeWreckStatus(){
        if(this.wreckStatus && this.activeWreck){
           return this.wreckStatus[this.activeWreck]
        }
       
      },
    activeWreck(){
        if(this.gameStatus){
           return this.gameStatus.activeWreck
        }
      },
       gameStatus(){
				return this.$store.getters.getGameStatus
      },
       mapInfo(){
        return this.$store.getters.getCurrentMap
      },
       knownDocs(){
      return this.$store.getters.getKnownDocs
    },
       locationInfo(){  
     
    if(this.mapInfo && this.mapInfo.locations && this.knownDocs){
      let locs=[]
      let loc
        for(var l in this.mapInfo.locations ){
          if(this.knownDocs.includes(this.mapInfo.locations[l].id) || this.showAll){ 
            
            this.$store.dispatch("retreiveLocation",this.mapInfo.locations[l].id)
            loc=this.$store.getters.getLocation(this.mapInfo.locations[l].id)
            if(loc){
              locs.push(loc)
            }
          }
        }
        
        return locs
    }
    },
    scanData(){
      return this.$store.getters.getScanData
    },
    foundData(){
      return this.$store.getters.getFoundData
    },
    shipLeft(){
       return this.coverLeft(this.imageWidth,this.imageHeight)
    },
    shipTop(){
       return this.coverTop(this.imageWidth,this.imageHeight)
    },
    shipScale(){
      return this.coverScale(this.imageWidth,this.imageHeight)
    },
    mapScale(){
      return this.containScale(542+50,478+50)
    },
    mapLeft(){
      return this.containLeft(542,478)+100*this.mapScale
    },
    mapTop(){
      return this.containTop(542,478)+25*this.mapScale
    }
  },
  methods:{
     itemByCode(code){
       if(this.items[this.wreck.id+code] ){
          return this.items[this.wreck.id+code] 
       }else{
         return {sCode:this.wreck.id+code,materials:"UNKNOWN"}
       }
      
    },
    searchUpdate(val,x,y){
       this.shipX=x
       this.shipY=y
       this.shipVal=val
      
    },
    doPolyUpdate(area){
     
        this.polyArea=area
        this.searchTime=Math.floor(parseInt(area,10)*.8)
        this.scanPaused=false
        this.timeSearched=0
         this.showActions=false
      },
      doPolyMove(){
       
        this.scanPaused=false
        this.scanBtnMode="isActive"
         this.showActions=false
      },
    zoomMap(){
      if(this.zoomScale==1){
        gsap.to(this,2,{zoomScale:1.8,zoomX:70})
      }else{
        gsap.to(this,2,{zoomScale:1,zoomX:50})
      }
    },
    zoomScan(){
      if(this.zoomScale==1){
        gsap.to(this,2,{zoomScale:1.8,zoomX:30})
      }else{
        this.zoomOut()
      }
    },
    zoomOut(){
      
        gsap.to(this,2,{zoomScale:1,zoomX:50})
      
    },
    startCourse(){
      this.$refs.scanMap.preScan()
      this.scanBtnMode="isScanning"
      this.detailBtnMode="isPassive",
      
      this.showScan=true
       this.showActions=false
      this.doScan=true
      this.scanText="Scanning..."
      if(!this.scanPaused){
        this.zoomOut()
        
        this.$refs.scanMap.preScan(this.mapInfo)
        this.$refs.scanMap.searchIndex++
      }else{
        this.scanPaused=false
      }
      this.$refs.scanMap.showPoints()
    },
   
    switchImage(image){
      this.depthMapPath=image
    },
    
    stopScan(){
      this.scanPaused=false
      this.doScan=false
      this.scanBtnMode="isActive"
       
    },

    showFound(){
      //("Show Actions")
      this.doScan=false
      this.$refs.scanMap.stopPlot()
      this.scanPaused=true
      this.$refs.scanMap.pointIndex++
      this.scanText="Object Detected<br>Materials: ["+this.foundItem.materials+"]<br>Dimensions: "+this.foundItem.dimensions
      this.scanBtnMode="isActive"
      this.diveBtnMode="isActive"
      this.detailBtnMode="isAvailable"
     
      switch(this.foundItem.match[0]){
         case "none":
           this.foundText=this.foundTextList[0]
         break
         case "material":
           this.foundText=this.foundTextList[1]
          break
         case "material,dimension":
           this.foundText=this.foundTextList[2]
         break
        default :
        this.foundText=this.foundTextList[0]
        
      }
 
      this.showActions=true;
    },
   
    doDive(foundVal){
      
      if(foundVal){
        this.foundItem=this.items[this.wreck.id+foundVal] 
         this.foundItem.foundVal=foundVal
        this.switchImage("depthMap-"+this.wreck.id+foundVal+".png")
      }
      if(this.foundItem){
            if(this.foundItem.foundVal==240){
            
              let modelPath=this.fireBaseLoc+"wrecks%2F"+this.wreck.model
              
              this.$store.commit("setDiveModel",modelPath)
              if(this.activeWreckStatus){
                this.activeWreckStatus.diveModel=modelPath
              } 
            }else{
             
              this.$store.commit("setDiveModel",this.foundItem.model)
              if(this.activeWreckStatus){
                this.activeWreckStatus.diveModel=this.foundItem.model
              } 
            }
      }

      this.transTo('dive','A Little Later')
    },
    showPoint(){
      this.$refs.scanMap.pointIndex++
    },
    slowPlot(){
      this.$refs.scanMap.slowPlot()
    },
   
    async loadMap(){
        let map
        if(!this.wreck){
            return
            map="Map-003"
        }else{
           
           map=this.wreck.maps[0]
        }
       
        await this.$store.dispatch('loadMap',map)
         this.map= this.$store.getters.getMap(map)
        
         this.$store.commit("setCurrentMap",map)
      },
    foundLoc(val,time){
        
        this.timeSearched+=time
        this.$store.dispatch('startTransition',{text:this.minsText(time*10)+" of scanning later..."})
        this.oceanTime=(this.oceanTime+time)%14+6
        let foundVal=this.foundData[val.findIndex].r
        this.foundItem=this.items[this.wreck.id+foundVal]
        this.foundItem.foundVal=foundVal
        if(this.foundItem){
           this.$store.commit("setDiveModel",this.foundItem.model)
           this.wreckStatus.diveModel=this.foundItem.model
        }
        //this.switchImage("depthMapP"+foundVal+".png")
        this.switchImage("depthMap-"+this.wreck.id+foundVal+".png")
        setTimeout(this.showPoint,9000)
        setTimeout(this.showFound,10000)
    },
    scanFinished(time){
      //this.doScan=false
      let self=this
      setTimeout(this.stopScan,6000)
      this.switchImage("depthMapEmpty.png")
      
      setTimeout(function(){
        self.scanText="Scan Finished"
         self.foundText= self.foundTextList[self.foundTextList.length-1]
         self.planBtnMode="isActive"
         self.detailBtnMode="isActive"
         self.scanBtnMode="inActive"
         self.diveBtnMode="inActive"
         self.showActions=true;
        },6000)
      
      this.$store.dispatch('startTransition',{text:this.minsText(time*10)+" of scanning later..."})
    },
    goTo(page,text){
        this.$router.push({ path: page})
      },
    transTo(page,text){
        let tText=text || "Meanwhile"
        this.$store.dispatch('startTransition',{text:tText,to:page})
    },
    minsText(mins){
      let hours=Math.floor(mins/60)
      if(hours >1){
        return hours+" hours"
      }else{
        return mins+" minutes"
      }
    }
  },
  watch:{
    activeWreck(val){
      
      this.$store.commit('setWreckByName',this.activeWreck)
      if(val){
        this.loadMap()
      }
      
    },
    wreck(val){
      
      if(val){
        this.loadMap()
      }
    },
     wrecks(val){
         
          if(this.activeWreck){
           this.$store.commit('setWreckByName',this.activeWreck)
           //this.loadMap()
          }
       },
  }
};
</script>

<style>
	.fullScreen{
		width:100%;
		height:100%;
    position:relative;
    background-color: #003;
    overflow:hidden;
    
  }
  .shipScan{
    width: 536px;
    height: 476px;
    background-color: #00003377;
    position: absolute;
    top: 538px;
    left: 355px;
    transform: rotateX(44deg);
  }
  .shipMap{
    width: 542px;
    height: 478px;
    background-color: #00003377;
    position: absolute;
    top: 538px;
    left: 1125px;
    transform: rotateX(44deg);
    transform-origin:50% 50%;
    pointer-events:auto;
    
  }
  .consoleBtns{
    pointer-events: auto;
     width: 113px;
    height: 470px;
    position: absolute;
    top: 538px;
    left: 952px;
     transform: rotateX(44deg);
  }
  .consoleBtn{
    font-size: 20px;
    font-weight: 900;
    text-align: center;
    font-weight: 900;
    height: 32px;
    width: 113px;
    margin-top: 37px;
    margin-bottom: 68px;
    cursor: pointer;
    border-radius: 20px;
  }
  .consoleBtn:hover{
     background-color: #00ff0077;
     box-shadow: #00ff0077 0px 0px 17px 4px;
  }
  .consoleBtn.isActive{
    background-color: #00ff0077;
    animation: pulse 2s infinite;
  }
  
  .consoleBtn.inActive{
    pointer-events: none;
  }
  .consoleBtn.isScanning{
    background-color: #ffcc0085;
    animation: pulseOrange 2s infinite;
    pointer-events: none;
  }
  .consoleBtn.isAvailable{
    background-color: #ffcc00cc;
   
  }

  .shipMapFS{
   
    background-color: #00003377;
    position: absolute;
    left:0px;
    top:0px;
    transform-origin:top left;
    transform:  rotateX(0deg);
  }
  .shipMapX2{
    width: 542px;
    height: 478px;
    background-color: #00003377;
    position: absolute;
    left:calc(50% - 542px);
    top:calc(50% - 478px);
    transform-origin:top left;
    transform: scale(2) rotateX(0deg);
  }
  .cockpit{
    transform-origin: top left;
    position:absolute;
    width:2000px;
    height:1125px;
    background-image:url("../assets/images/ship/cockpit3.png");
    background-size:cover;
    perspective: 2000px;
     perspective-origin: 50%;  
     pointer-events:none;
  }
  .shipHUD{
    padding: 10px;
    text-shadow: rgb(0, 255, 0) 0px 0px 7px;
    font-size: 22px;
    text-align: left;
    pointer-events: auto;
    position: absolute;
    border-radius:5px;
    color:#02e1f2;
    width: 1220px;
    height: 113px;
    background-color: #00000066;
    left: 390px;
    top: 390px;
  }
  .shipHUD .lhs{
    position: absolute;
    top:20px;
    left: 30px;
    width: 500px;
    text-align: left;
   
  }
  .shipHUD .rhs{
    position: absolute;
    top:20px;
    right: 130px;
    width: 500px;
    text-align: right;
   
  }
  .cockpitJSR{
    position:absolute;
    width:200px;
    height:173px;
    bottom: 0px;
    left:1300px;
    background-image:url("../assets/images/ship/cockpitJSR.png");
    pointer-events:auto;
  }
  .cockpitJSL{
    position:absolute;
    width:200px;
    height:173px;
    left:500px;
    bottom: 0px;
    background-image:url("../assets/images/ship/cockpitJSL.png");
    pointer-events:auto;
  }
  .scanDetails{
    position:absolute;
    top:0px;
    bottom:0px;
    left:0px;
    right:0px;
    margin:auto;
    width:800px;
    height:350px;
    background-color: #000000;
    opacity: 0.7;
    color:#fff;
  }
  .scanInfo{
    text-align: left;
    padding: 0px 20px;
    margin-bottom:10px;
  }
  .locDiveBtn{
    color: #fff;
    font-weight: 500;
    float: right;
    position: relative;
    top: -30px;
    padding: 5px;
    border-left: #fff solid 2px;
    border-right: #fff solid 2px;
    border-radius: 5px;
    cursor: pointer;
    background-color:#000A;
  }
  .locDiveBtn:hover{
    background-color:#fff3;
  }
@keyframes pulse {
	0% {	 background-color: #00ff0033;	}
	50% { background-color: #00ff00aa;	}
	100% {	 background-color: #00ff0033;	}
}
@keyframes pulseOrange {
	0% {	 background-color: #ffcc0077;	}
	50% { background-color: #ffcc00ff;	}
	100% {	 background-color: #ffcc0077;	}
}

</style>